
import React, { useState } from 'react';
import { getTimeTasksInStatus, getAllMonthSprints } from '../components/api';
import { $taskExecutionTime, setTaskExecutionTime } from '../store/cards';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    IconButton
} from '@mui/material';
import {
    ArrowLeft,
    ArrowRight,
} from '@mui/icons-material';
import '../styles/month-report.scss';
import { useStore } from 'effector-react';


export const TaskExecutionTimeReportPage = () => {
    const taskExecutionTime = useStore($taskExecutionTime);
    const [sprints, setSprints] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [gradientValues, setGradientValues] = useState([]);
    const [selectedSprint, setSelectedSprint] = useState(`${new Date().getMonth() + 1};${new Date().getFullYear()}`);

    function createGradientList(count, startColor, endColor) {
        const colors = [];

        for (let i = 0; i < count; i++) {
            const ratio = count === 1 ? 0 : i / (count - 1);

            // Линейная интерполяция между цветами
            const r = Math.round(startColor[0] * (1 - ratio) + endColor[0] * ratio);
            const g = Math.round(startColor[1] * (1 - ratio) + endColor[1] * ratio);
            const b = Math.round(startColor[2] * (1 - ratio) + endColor[2] * ratio);

            // Преобразуем в HEX и добавляем в массив
            colors.push(rgbToHex(r, g, b));
        }

        return colors;
    }

    function rgbToHex(r, g, b) {
        return "#" + [r, g, b].map(x => {
            const hex = x.toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }).join("").toUpperCase();
    }

    React.useEffect(() => {
        document.title = "TaskMan - Время выполнения задач";
    });

    React.useEffect(() => {
        getAllMonthSprints().then(data => setSprints(data));
        if (sprints.length) {
            setSelectedSprint(`${sprints[0].month};${sprints[0].year}`);
        }
    }, [sprints.length]);

    React.useEffect(() => {
        const { month, year } = getSprintData();
        getTimeTasksInStatus(year, month).then(timeTasksInStatus => {
            setTaskExecutionTime(timeTasksInStatus.tasks);
            const colors = createGradientList(timeTasksInStatus.maxValue, [104, 239, 35], [243, 32, 38]);
            console.log(colors);
            setGradientValues(colors);
            setIsLoaded(true);
        });
        setIsLoaded(true);
    }, [isLoaded, selectedSprint]);

    const getSprintMonthYearToSelect = (sprint) => {
        return sprint ? `${sprint.month};${sprint.year}` : `${new Date().getMonth() + 1};${new Date().getFullYear()}`;
    }

    const getSprintData = () => {
        const sprintData = selectedSprint.target ? selectedSprint.target.value : selectedSprint;
        const [month, year] = sprintData.split(';');
        return {
            month: month,
            year: year
        }
    }

    const previousMonth = () => {
        const { month, year } = getSprintData();
        const date = new Date(`${year}-${month}-01`);
        date.setMonth(date.getMonth() - 1);
        setSelectedSprint(`${date.getMonth() + 1};${date.getFullYear()}`)
    }

    const nextMonth = () => {
        const { month, year } = getSprintData();
        const date = new Date(`${year}-${month}-01`);
        date.setMonth(date.getMonth() + 1);
        setSelectedSprint(`${date.getMonth() + 1};${date.getFullYear()}`)
    }

    const changeSelectedSprint = (event) => {
        setSelectedSprint(event.target.value);
    }

    const formattedData = (month, year) => {
        var options = {
            year: 'numeric',
            month: 'long',
            timezone: 'UTC'
        };
        const date = new Date(`${year}-${month}-01`);
        return `${date.toLocaleString("ru", options)}`
    };

    const getBackgroundColor = (differentValue) => {
        return gradientValues[Math.round(differentValue)] + "66";
    }

    return (
        <div>
            <div className='month-report__month-controls'>
                <IconButton
                    style={{ padding: 0 }}
                    onClick={() => previousMonth()}
                    disabled={getSprintMonthYearToSelect(sprints[sprints.length - 1]) === selectedSprint}
                >
                    <ArrowLeft />
                </IconButton>
                <Select className='month-report__sprints-combobox' onChange={changeSelectedSprint} value={selectedSprint}>
                    {sprints.map((sprint) => {
                        return (<MenuItem value={getSprintMonthYearToSelect(sprint)} key={sprint.month + sprint.year}>{`${formattedData(sprint.month, sprint.year)}`}</MenuItem>)
                    })}
                </Select>
                <IconButton
                    style={{ padding: 0 }}
                    onClick={() => nextMonth()}
                    disabled={getSprintMonthYearToSelect(sprints[0]) === selectedSprint}
                >
                    <ArrowRight />
                </IconButton>
            </div>
            <h3>Задачи</h3>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 300 }} size="small" aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell width={10} align="center"><b>№</b></TableCell>
                            <TableCell width={400} align="center"><b>Заголовок</b></TableCell>
                            <TableCell width={10} align="center"><b>Запланирована</b></TableCell>
                            <TableCell width={10} align="center"><b>В работе</b></TableCell>
                            <TableCell width={10} align="center"><b>Уточнения</b></TableCell>
                            <TableCell width={10} align="center"><b>На ревью</b></TableCell>
                            <TableCell width={10} align="center"><b>На исправлении</b></TableCell>
                            <TableCell width={10} align="center"><b>На проверке</b></TableCell>
                            <TableCell width={10} align="center"><b>На доработке</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {taskExecutionTime.map((task) =>
                            <TableRow key={task.id}>
                                <TableCell width={10} align="center">
                                    <a
                                        href={`https://bitrix.borauto.ru/company/personal/user/1835/tasks/task/view/${task.task_id}/`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {task.task_id}
                                    </a>
                                </TableCell>
                                <TableCell width={400} align="left">{task.title}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.to_do) }}>{task.to_do}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.in_progress) }}>{task.in_progress}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.review_clarifications) }}>{task.review_clarifications}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.on_review) }}>{task.on_review}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.under_correction) }}>{task.under_correction}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.under_review) }}>{task.under_review}</TableCell>
                                <TableCell width={10} align="center" style={{ background: getBackgroundColor(task.under_development) }}>{task.under_development}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}